import React from "react";
import ct from "class-types.macro";
import { LinkedResourceResult } from "~/common/Store/models/Category";
import useIsMounted from "~/common/useIsMounted";
interface Props {
  linkedResources: LinkedResourceResult[];
}
const RelatedResourcesLeaf = ({
  linkedResources
}: Props) => {
  const pseudoRandomIndex = Math.floor(Math.random() * 100) % linkedResources.length;
  const resource = linkedResources[pseudoRandomIndex];
  const mounted = useIsMounted();
  return <>
      {mounted && <div id="SHQ-plpheader" className={`page-header-promo ${ct("block", "float-none", "mt-0")}`}>
          <a href={resource!.link} className="header__promo-block xl:float-right xl:flex justify-center bg-white border border-solid border-gray-200 rounded xs:m-0 m-2 p-3 pr-2 items-center" target="_blank" rel="noopener noreferrer">
            <span className="header__promo-image border-0">
              <img className="svg-resource" src="//cdnimg.webstaurantstore.com/uploads/design/2017/3/resource.svg" alt="" />
            </span>
            <span className="header__promo-text">
              <span className="header__promo-title">
                Don&apos;t know where to start?
              </span>
              {}
              <span className="header__promo-action">{resource!.title}</span>
              <span className="sr-only">opens in a new tab</span>
            </span>
          </a>
        </div>}
    </>;
};
export default RelatedResourcesLeaf;